import classNames from "classnames";
import { ComponentPropsWithRef } from "react";

import css from "./tile.module.scss";

type TileProps = ComponentPropsWithRef<"div"> & {
  variant?: "default" | "light" | "selected" | "error";
  border?: boolean;
  paddingVariant?: "none" | "sm" | "md" | "lg" | "xl";
  qaId?: string;
};

export const Tile = ({
  ref,
  className,
  children,
  variant = "default",
  border,
  paddingVariant = "sm",
  style,
  qaId,
  ...props
}: TileProps) => (
  <div
    ref={ref}
    className={classNames(css.tile, className, {
      [css.light]: variant === "light",
      [css.selected]: variant === "selected",
      [css.error]: variant === "error",
      [css.border]: border,
      [css.noPadding]: paddingVariant === "none",
      [css.smallPadding]: paddingVariant === "sm",
      [css.mediumPadding]: paddingVariant === "md",
      [css.largePadding]: paddingVariant === "lg",
      [css.xlargePadding]: paddingVariant === "xl"
    })}
    style={style}
    data-qa-id={qaId}
    {...props}
  >
    {children}
  </div>
);
